import { HAPANA_BASE_DOMAINS } from '@hapana/shared/web/utils/environment'

/**
 * The environment's base domain when `hostname` is Core's bare domain (apex or `www.`),
 * otherwise null. The bare domain has no tenant subdomain, so the gateway cannot resolve a
 * corporate for tenant-scoped auth flows (login link, password reset) from it.
 */
export const getBareCoreDomain = (hostname: string): string | null => {
  const host = hostname.toLowerCase().replace(/^www\./, '')
  return HAPANA_BASE_DOMAINS.includes(host) ? host : null
}
